// extracted by mini-css-extract-plugin
module.exports = {"authButtonsContainer":"AuthButtons_authButtonsContainer__7tZ5L","signButton":"AuthButtons_signButton__4_w74"};